import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { SubmitButton } from '@/components/ui/submit-button'
import { ChatActionWithValue } from '../../models/insuranceApplication'
import { ChatCarrierNameSearch } from './ChatCarrierNameSearch'

interface ChatDotNumberProps {
  maxLength?: number
  placeholder?: string
  /** Where a visitor without a DOT goes instead — offered to anonymous visitors only. */
  noDotHref?: string
  handleSubmit: (data: ChatActionWithValue | FormData) => void
  readonly?: boolean
}

export function ChatDotNumber({
  maxLength = 8,
  placeholder = 'DOT number',
  noDotHref,
  handleSubmit,
  readonly,
}: ChatDotNumberProps) {
  const [value, setValue] = useState('')
  const [searchingByName, setSearchingByName] = useState(false)

  function onSubmit() {
    if (!value) return
    handleSubmit({
      content: {
        component: 'P',
        content: value,
      },
      value,
    })
  }

  if (searchingByName) {
    return (
      <ChatCarrierNameSearch
        handleSubmit={handleSubmit}
        onEnterDot={() => setSearchingByName(false)}
        readonly={readonly}
      />
    )
  }

  return (
    <div className="mt-2 w-full">
      <div className="flex justify-end">
        <Input
          id="dot_number"
          name="dot_number"
          type="text"
          inputMode="numeric"
          pattern="\d*"
          autoComplete="off"
          placeholder={placeholder}
          maxLength={maxLength}
          value={value}
          onChange={(e) => setValue(e.target.value.replace(/\D/g, '').slice(0, maxLength))}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              onSubmit()
            }
          }}
          disabled={readonly}
          className="w-full max-w-64"
        />
      </div>

      <div className="mt-4 flex flex-wrap items-center justify-end gap-2">
        {noDotHref && (
          <Button variant="ghost" href={noDotHref}>
            I don&apos;t have a DOT yet
          </Button>
        )}

        <Button type="button" variant="ghost" onClick={() => setSearchingByName(true)} disabled={readonly}>
          I don&apos;t remember my DOT
        </Button>

        <SubmitButton onClick={onSubmit} disabled={readonly || !value} />
      </div>
    </div>
  )
}
